/* eslint-disable max-lines-per-function */
import React, { useState } from "react"
import { latencyComp } from "../../constants"

import { 
  gameAnswerUpdate, 
  gameQuestionUpdate, 
  gameResetCountdown,
  gameRulesUpdate, 
  gameScoresUpdate,
  gameSkinUpdate, 
  gameStartCountdown,
  gameStartInfoUpdate, 
  gameTotalPlayersUpdate,
  gameUpdateIsFinalScore,
  gameUpdateIsRevealed,
} from "/src/redux/actions"
import { useDispatch, useSelector } from "react-redux"
import Leaderboard from "./Scoreboard"
import { QUIZ_PANEL_INTRO_ANIMATION_DURATION } from "/src/constants"
import Question from "./Question"
import Rules from "./Rules"
import { usePubSubListener } from "/src/hooks"


// const key = "Question"
const channelId = window.location.hash.slice(1)

const Quiz = () => {

  const game = useSelector(state => state.game)
  const dispatch = useDispatch()
  const [gamePhase, setGamePhase] = useState()

  usePubSubListener(channelId, data => {
    console.log("[ Quiz ] Received pubsub message!", data)

    if (data.username)
      return // ABORT ABORT ITS A FLEX

    if (data.gameMode) {
      game.isRevealed = data.isRevealed
    }

    const { 
      phase,
      skin,
    } = data

    setGamePhase(phase)
    dispatch(gameSkinUpdate(skin))

    if (phase === "Start") {
      const {
        title,
        tagline,
        gameMode,
      } = data

      dispatch(gameRulesUpdate(title, tagline, gameMode))
    }
    else if (phase === "NextQuestion") {
      const {
        isRevealed,
        maxTime,
        question, 
      } = data

      setGamePhase("empty")
      setGamePhase("NextQuestion")

      dispatch(gameStartInfoUpdate(maxTime))
      dispatch(gameQuestionUpdate(question))
      dispatch(gameUpdateIsRevealed(isRevealed))

      setTimeout(() => dispatch(gameStartCountdown()), (QUIZ_PANEL_INTRO_ANIMATION_DURATION + (latencyComp * 1000)))
    } 
    else if (phase === "Reveal") {
      const {
        answersSelectedBy,
        isRevealed,
      } = data

      dispatch(gameResetCountdown())
      dispatch(gameAnswerUpdate(answersSelectedBy))
      dispatch(gameUpdateIsRevealed(isRevealed))
    } 
    else if (phase === "GetPointsAll") {
      const {
        isFinalScore,
        questionScores,
        totalPlayers, 
        totalScores,
      } = data

      dispatch(gameScoresUpdate({ questionScores, totalScores }))
      dispatch(gameUpdateIsFinalScore(isFinalScore))
      dispatch(gameTotalPlayersUpdate(totalPlayers))
    }
  })

  switch (gamePhase) {
  case "Start":
    return (
      <Rules />
    )
  case "NextQuestion":
    return (
      <Question />
    )
  case "Reveal":
    return (
      <Question />
    )
  case "GetPointsAll":
    return (
      <Leaderboard />
    )
  default:
    return (
      <div>
        { console.log("no case") }
      </div>
    )
  }
}

export default Quiz